import {Utils, EventBus} from '../app.base';
import {Vue, Routes, MsgBox} from '../app.vues';
import {RouteLayerMgr} from '../compo/ctrl/RouteLayer';
//
import userApi from '../api/user';
import goodsCategApi from '../api/goodsCateg';
//
let cachedFailFlagValue = -1;
//
//缓存当前用户上下文scopeEntity（-1：失败标记）
let cachedScopeEntity = null;
//缓存当前用户上下文权限资源信息（-1：失败标记）
let cachedUserPostRescMap = null;
//生成 url 层次片段
//minParts : 最小片段数
//toHierUrlPaths('/org/struct/com/main', 2) = > ["/org/struct/com/main","/org/struct/com","/org/struct"]
function toHierUrlPaths(url, minParts) {
    minParts = minParts || 1;
    //
    if (url.charAt(0) == '/') {
        url = url.substring(1);
    }
    //
    let pathParts = url.split('/');
    pathParts = pathParts.map(function (part) {
        return '/' + part;
    });
    //
    let retUrls = [];
    for (let i = pathParts.length; i >= minParts; i--) {
        retUrls.push(pathParts.join(''));
        pathParts.pop();
    }
    //
    if (retUrls.length == 0) {
        retUrls.push(pathParts.join(''));
    }
    //
    return retUrls;
}

//获取并缓存当前用户上下文ScopeEntity信息
export function getUserScopeEntity() {
    if (cachedScopeEntity == null) {
        userApi.getUserInfoByContext({}, function (result) {
            if (result.type == 'info') {
                let userContext = result.data || {};
                let scopeEntity = userContext.scopeEntity || {};
                cachedScopeEntity = !scopeEntity.scopeCode ? cachedFailFlagValue : scopeEntity;
            } else {
                cachedScopeEntity = cachedFailFlagValue;
                //
                MsgBox.warning('获取用户组织信息失败');
            }
        });
    }
    //
    return cachedScopeEntity;
}

//检查用户权限信息 aspectType : action, info, ...
function checkUserAspectPerm(compOrPath, aspectValue = null, aspectType = null, dataOwnerComId = null) {
    getUserScopeEntity();
    //
    if (cachedScopeEntity == null || cachedScopeEntity == cachedFailFlagValue) {
        return false;
    }
    //
    if (cachedUserPostRescMap == null) {
        userApi.getUserPostRescListByContext({}, function (result) {
            if (result.type == 'info') {
                let userPostRescList = result.data || [];
                //
                cachedUserPostRescMap = {};
                //
                userPostRescList.forEach(function (resc) {
                    if (resc.type === 0) {
                        //只处理hashUrl
                        //actions
                        let actionList = resc.actionList || null;
                        if (actionList == null) {
                            if (resc.actions) {
                                actionList = resc.actions.split('|');
                            } else {
                                actionList = [];
                            }
                            //
                            resc.actionList = actionList;
                        }
                        //
                        resc.pattern = resc.pattern.trim();
                        //
                        cachedUserPostRescMap[resc.pattern] = resc;
                    }
                });
            } else {
                cachedUserPostRescMap = cachedFailFlagValue;
                //
                MsgBox.warning('获取权限信息失败');
            }
        });
    }
    //
    if (cachedUserPostRescMap == null || cachedUserPostRescMap == cachedFailFlagValue) {
        return false;
    }
    //
    let hashUrl = compOrPath;
    aspectType = aspectType || 'action';
    //
    if (compOrPath == null) {
        console.error('请指定要检查权限/操作的目标组件 或 path/url');
        //
        return false;
    } else if (typeof compOrPath !== 'string') {
        if (compOrPath.authen === false) {
            return true;
        }
        //
        hashUrl = compOrPath.fullPath || compOrPath.path;
    }
    //
    if (hashUrl) {
        let resc = null;
        let hierUrls = toHierUrlPaths(hashUrl, 2);
        for (let i = 0; i < hierUrls.length; i++) {
            resc = cachedUserPostRescMap[hierUrls[i]];
            if (resc != null) {
                console.log('匹配的权限资源：' + resc.pattern);
                break;
            }
        }
        if (resc == null) {
            return false;
        }
        //action
        if (aspectType == 'action' && aspectValue) {
            if (resc.actionList.indexOf(aspectValue) == -1) {
                return false;
            }
        }
        //
        return true;
    } else {
        console.error('要检查权限/操作的目标组件没有path信息 或 不是 path 或 不是组件');
        //
        return false;
    }
}

//带二级缓存检查用户操作（可选的是否为指定岗位）权限
export function checkUserActionPermFor(compOrPath, action = null, targetPostId = null, dataOwnerComId = null) {
    //检查操作
    let result = checkUserAspectPerm(compOrPath, action, 'action', dataOwnerComId);
    //检查岗位是否为指定的岗位
    if (result === true && typeof targetPostId === 'number') {
        result = cachedScopeEntity.postId == targetPostId;
    }
    //
    return result;
}

//为路由添加全局权限拦截
export function setRouterPermGuard(router) {
    router.beforeEach(function (to, from, next) {
        let passed = true;
        //
        let pathTo = to.path;
        let pathFrom = from.path;
        //
        console.log(pathFrom + "  =>  " + pathTo);
        //
        let comp = Routes.get(pathTo);
        if (comp != null) {
            passed = checkUserActionPermFor(comp);
        }
        if (passed) {
            //路由弹层 切换
            RouteLayerMgr.setRoutePath(pathTo, true);
            //
            next();
        } else {
            if (comp.__file) {
                console.warn('未授权 资源对应组件 ：' + comp.__file);
            }
            //
            MsgBox.warning('目标资源未授权（"' + comp.desc + '"）');
            //
            next(false);
        }
    });
}

//
let global_userActionPermCache = {};
let checkActionPermCode = '        // 检查资源具体操作权限（可选的岗位id，数据所属公司id）\n' +
    '        checkActionPerm: function (action, targetPostId = null, dataOwnerComId = null) {\n' +
    '            let pathUrl = null;//默认自动获取当前组件类的path\n' +
    '            return checkUserActionPerm.call(this, pathUrl, action, targetPostId, dataOwnerComId);\n' +
    '        },';

//带一级缓存的基于上下文的资源、操作、数据权限检查
export function checkUserActionPerm(pathUrl = null, action = null, targetPostId = null, dataOwnerComId = null) {
    if (pathUrl == null) {
        console.error('无效的路径 path or url');
        //
        return false;
    }
    let userActionPermCache = global_userActionPermCache;
    //
    let cacheKey = pathUrl + "::" + (action == null ? "" : action) + "::" + (targetPostId == null ? "" : targetPostId) + "::" + (dataOwnerComId == null ? "" : dataOwnerComId);
    let cacheValue = userActionPermCache[cacheKey];
    if (cacheValue == null) {
        //原生调用
        cacheValue = checkUserActionPermFor(pathUrl, action, targetPostId, dataOwnerComId);
        userActionPermCache[cacheKey] = cacheValue;
    } else {
        // console.log('got perm action info from cache');
    }
    return cacheValue;
}

export function getUserRescByUrl(url = null) {
    let resc = null;
    if (cachedUserPostRescMap == null) {
        checkUserActionPermFor("/");
    }
    if (cachedUserPostRescMap != null) {
        resc = cachedUserPostRescMap[url];
    }
    return resc;
}

let EB = EventBus.get('sidebar');

// name ：面包屑名称， parentBreadcrumbUrl ：所属一级url
export function syncSetBreadcrumb(name, parentBreadcrumbUrl) {
    let breadcrumb = {
        name: name,
        parentBreadcrumbUrl: parentBreadcrumbUrl
    };
    setTimeout(function () {
        EB.trigger('sidebar:syncSetBreadcrumbList', breadcrumb);
    }, 500);
}

// 当前频道
let thisSysMenuChnl = null;

export function syncSysMenuChnl(sysMenuChnl) {
    thisSysMenuChnl = sysMenuChnl;
}

export function getThisSysMenuChnl() {
    if (thisSysMenuChnl != null && thisSysMenuChnl.id != null) {
        return thisSysMenuChnl;
    } else {
        return null;
    }
}





//////////////////
// WEBPACK FOOTER
// ./src/compo/index.js
// module id = 4
// module chunks = 1